import { atomWithStorage } from 'jotai/utils'

import { STORAGE_KEY } from '@/constants/common'
import {
  // DEFAULT_FEE_MODE,
  DEFAULT_PREFERRED_EXPLORER,
  DEFAULT_RPC_ENDPOINT,
  // DEFAULT_TRANSACTION_BROADCASTING,
  DEFAULT_TRANSACTION_SETTING,
  // FeeMode,
  ITxSettingProps,
  PreferredExplorer,
  RPCEndpointKey,
  SUPPORT_RPC_ENDPOINT
  // TransactionBroadcasting
} from '@/constants/settings'
import { TokenOrderColumn } from '@/hooks/services/useTokenList'
import { createIndexedDBStorage } from '@/stores/indexedDB'

export const preferredExplorerAtom = atomWithStorage<PreferredExplorer>(
  STORAGE_KEY.PEFERRED_EXPLORER,
  DEFAULT_PREFERRED_EXPLORER.url,
  undefined,
  {
    getOnInit: true
  }
)

// export const rpcEndpointAtom = atomWithStorage<string>(
//   STORAGE_KEY.RPC_ENDPOINT,
//   DEFAULT_RPC_ENDPOINT.url,
//   undefined,
//   {
//     getOnInit: true
//   }
// )

// export const transactionBroadcastingAtom =
//   atomWithStorage<TransactionBroadcasting>(
//     STORAGE_KEY.TRANSACTION_BROADCASTING,
//     DEFAULT_TRANSACTION_BROADCASTING.value,
//     undefined,
//     {
//       getOnInit: true
//     }
//   )

// export const feeModeAtom = atomWithStorage<FeeMode>(
//   STORAGE_KEY.FEE_MODE,
//   DEFAULT_FEE_MODE.value,
//   undefined,
//   {
//     getOnInit: true
//   }
// )

// export const feeAtom = atomWithStorage<string>(STORAGE_KEY.FEE, '', undefined, {
//   getOnInit: true
// })

// export const transactionSettingAtom = atomWithStorage<ITxSettingProps>(
//   STORAGE_KEY.TRANSACTION_SETTING,
//   DEFAULT_TRANSACTION_SETTING,
//   undefined,
//   {
//     getOnInit: true
//   }
// )

export const transactionSettingAtom = atomWithStorage<ITxSettingProps>(
  STORAGE_KEY.TRANSACTION_SETTING,
  DEFAULT_TRANSACTION_SETTING,
  createIndexedDBStorage(),
  {
    getOnInit: true
  }
)

export const eventNotificationsTimerAtom = atomWithStorage<number | string>(
  STORAGE_KEY.EVENT_NOTIFICATIONS_TIMER,
  '',
  undefined,
  {
    getOnInit: true
  }
)

export const tokenSortTypeAtom = atomWithStorage<TokenOrderColumn>(
  STORAGE_KEY.TOKEN_SORT_TYPE,
  TokenOrderColumn.CreateAt,
  undefined,
  {
    getOnInit: true
  }
)

export const rpcSettingAtom = atomWithStorage<{
  rpcKey: string
  rpcUrl: string
}>(
  STORAGE_KEY.RPC_SETTING,
  undefined as any,
  {
    getItem: (key: string) => {
      const raw = localStorage.getItem(key)
      let rpcEndpointValue
      if (raw) {
        try {
          const rpcSetting = JSON.parse(raw)
          // 非用户自定义的，通过key从预设中取url
          if (rpcSetting?.rpcKey) {
            const item = SUPPORT_RPC_ENDPOINT.find(
              (item) => item.key === rpcSetting.rpcKey
            )
            if (item?.key === RPCEndpointKey.Custom) {
              if (rpcSetting.rpcUrl) {
                rpcEndpointValue = item
                rpcEndpointValue.url = rpcSetting.rpcUrl
              }
            } else {
              rpcEndpointValue = item
            }
          }
        } catch {
          rpcEndpointValue = undefined
        }
      }
      if (!rpcEndpointValue) {
        rpcEndpointValue = DEFAULT_RPC_ENDPOINT
      }
      return {
        rpcKey: rpcEndpointValue.key,
        rpcUrl: rpcEndpointValue.url
      }
    },
    setItem: (key: string, newValue: any) => {
      localStorage.setItem(key, JSON.stringify(newValue))
    },
    removeItem: (key: string) => {
      localStorage.removeItem(key)
    }
  },
  { getOnInit: true }
)
